import { render, staticRenderFns } from "./ManageUsersModule.vue?vue&type=template&id=643edcba"
import script from "./ManageUsersModule.vue?vue&type=script&lang=js"
export * from "./ManageUsersModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports